import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { NotEnoughQuotaTooltip } from "app/pages/sales-intelligence/modules/quota/components/NotEnoughQuotaTooltip";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { StyledSubmitButton } from "../../../../../common-components/MultiSelector/Buttons/styles";

interface IProps {
    remainingRevealQuota: number;
    contactsTotalCount: number;
    contactsToRevealCount: number;
    isNotEnoughCredits?: boolean;
    areSearchResultsFetching?: boolean;
    className?: string;
    isLoading?: boolean;
    onClick: VoidFunction;
}

const ActiveRevealActionButton = ({
    className,
    isNotEnoughCredits,
    remainingRevealQuota,
    areSearchResultsFetching,
    contactsTotalCount,
    contactsToRevealCount,
    isLoading = false,
    onClick,
}: IProps): ReactElement => {
    const { translate } = useTranslate();

    const isDataCreditsEnabled = salesSettingsHelper.isDataCreditsEnabled;

    const isDisabledByDataCredits = isDataCreditsEnabled && isNotEnoughCredits;
    const isDisabled =
        isDisabledByDataCredits ||
        remainingRevealQuota === 0 ||
        areSearchResultsFetching ||
        contactsTotalCount === 0 ||
        contactsToRevealCount === 0;

    const button = (
        <StyledSubmitButton
            className={className}
            isLoading={isLoading}
            isDisabled={isDisabled}
        >
            <Button
                onClick={onClick}
                isDisabled={isDisabled}
                isLoading={isLoading}
                dataAutomation="contacts-actions-panel.reveal-submit-button"
            >
                {translate("si.advanced_search.contacts_search.action.reveal.label")}
            </Button>
        </StyledSubmitButton>
    );

    if (isDisabledByDataCredits) {
        return (
            <NotEnoughQuotaTooltip
                quota={remainingRevealQuota}
                isAdmin={salesSettingsHelper.isAdmin()}
                isNoTouch={isNoTouch(swSettings)}
                isTrial={isTrial(swSettings)}
            >
                {button}
            </NotEnoughQuotaTooltip>
        );
    }

    return button;
};

export default ActiveRevealActionButton;
